module.exports = __webpack_public_path__ + "img/dy.a282f720.png";